'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
import type * as React from 'react';
import { Typography } from '../Typography/Typography';
import { useTagContext } from './context/useTagContext';
import type { TagSize } from './types';
const SIZE_TO_TYPO: Record<TagSize, 'caption-4' | 'caption-2' | 'body-4'> = {
  small: 'caption-4',
  // JP/Caption/C4_B
  medium: 'caption-2',
  // JP/Caption/C2_B
  large: 'body-4' // JP/Body/B4_B
};
export type TagLabelProps = {
  className?: string;
  children?: React.ReactNode;
};
export function TagLabel(t0) {
  const $ = _c(8);
  const {
    className,
    children
  } = t0;
  const {
    size
  } = useTagContext();
  const t1 = SIZE_TO_TYPO[size];
  let t2;
  if ($[0] !== className) {
    t2 = cn("truncate", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== t2) {
    t3 = <span className={t2}>{children}</span>;
    $[2] = children;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <Typography asChild={true} variant={t1} weight="bold" color="inherit">{t3}</Typography>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}